import { Endpoint } from '@business/api/endpoint';
import {
  CompactProposalTemplateFolderResponse,
  CompactProposalTemplateItemResponse,
  FolderId,
  ItemId,
  ProposalTemplateFolderStructureResponse,
} from '@business/entities/proposal';
import { R } from '@core/utils/r';
import { CommonService } from '@business/services';
import { DashboardTemplateItemsResponse, DashboardTemplateItemType, DashboardTemplateResponse } from '@business/entities/dashboardTemplate';
import { DashboardResponse } from '@business/entities/dashboard';

export function getItems(parentId?: FolderId, search?: string) {
  return Endpoint.get<DashboardTemplateItemsResponse>(`@gc/dashboard-template`, { params: R.objectCompact({ parentId, search }) });
}

export function getFolders() {
  return Endpoint.get<CompactProposalTemplateFolderResponse[]>(`@gc/dashboard-template/folders`);
}

/** Folders **/
export function createFolder(name: string, parentId?: FolderId) {
  return Endpoint.post<DashboardTemplateResponse>(`@gc/dashboard-template`, { data: { name, parentId } });
}

export function renameFolder(id: FolderId, name: string) {
  return Endpoint.patch<DashboardTemplateResponse>(`@gc/dashboard-template/${id}`, { data: { name } });
}

export function deleteFolder(id: FolderId) {
  return Endpoint.delete<void>(`@gc/dashboard-template/${id}`);
}

/** Items **/

export function getItem(id: ItemId, type: string) {
  return Endpoint.get<DashboardResponse>(`@gc/dashboard-template/item/${id}`);
}

export function getItemPublic(id: ItemId) {
  return Endpoint.get<DashboardResponse>(`@gc/public/dashboard-template/item/${id}`);
}

export function createItem(data: Partial<DashboardResponse>, parentId?: FolderId) {
  data.parentFolderId = parentId;
  return Endpoint.post<DashboardResponse[]>(`@gc/dashboard-template/item`, { formData: CommonService.toFormData(data), hasFiles: true });
}

export function duplicateItem(id: ItemId, name: string) {
  return Endpoint.post<DashboardResponse>(`@gc/dashboard-template/duplicate/${id}`, { data: { name } });
}

export function updateItem(data: Partial<DashboardResponse>, itemId: ItemId) {
  return Endpoint.post<DashboardResponse>(`@gc/dashboard-template/update-item/${itemId}`, {
    formData: CommonService.toFormData(data),
    hasFiles: true,
  });
}

export function deleteItem(id: ItemId) {
  return Endpoint.delete<void>(`@gc/dashboard-template/item/${id}`);
}

export function getProposalTemplateItems(type: string) {
  return Endpoint.get<CompactProposalTemplateItemResponse[]>(`@gc/dashboard-template/items`, { params: { type } });
}

export function folderStructure(folderId: FolderId) {
  return Endpoint.get<ProposalTemplateFolderStructureResponse>(`@gc/dashboard-template/folder-structure`, { params: { folderId } });
}

export function move(id: string, type: DashboardTemplateItemType, destinationId: string) {
  return Endpoint.post<void>(`@gc/dashboard-template/move`, { data: { id, type, destinationId } });
}

export function updateFormData(id: ItemId, data: string) {
  return Endpoint.post<DashboardResponse>(`@gc/dashboard-template/update-form-data/${id}`, { data: { data } });
}
